import React from "react";
import "./experience.css";
import Separator from "../../common/separator";
import { ExperienceData } from "../../data/experience";
import ExperienceCard from "./experience-card";
function Experience() {
  const data = ExperienceData;
  return (
    <div className="experience">
      <Separator />
      <label className="section-title">Experience</label>
      <div className="experience-list">
        {data.map((item) => {
          return <ExperienceCard item={item} key={item.company} />;
        })}
      </div>
    </div>
  );
}

export default Experience;
